import React from 'react';
import styled from 'styled-components';
import SelectedAnswers from './SelectedAnswers';
import Text from '../../Common/Form/Text';
import Price from './Price';

const CotizacionWrapper = styled.div`
  .Cotizacion {
    &-title {
      margin-bottom: 30px;
      color: var(--text-color-2);
    }
  }
`;

const Cotizacion = props => (
  <CotizacionWrapper>
    <Text className="Cotizacion-title">Nuestra mejor cotización para vos</Text>

    <SelectedAnswers />

    <Price />
  </CotizacionWrapper>
);

export default Cotizacion;
